'use client';

export type IdleLevelsState = {
	idle1Min: boolean;
	idle10Min: boolean;
};

const DEFAULT_STATE: IdleLevelsState = {
	idle1Min: false,
	idle10Min: false,
};

// Idle tracking is currently disabled. We intentionally do NOT call `useIdle`
// here: each call registers mousemove/keydown/visibility listeners and a timer,
// and this hook has multiple consumers (useIdlePollingRateSwitcher and
// useSyncMarketDataWithDlobServerPolling), so calling it would spin up several
// listener/timer sets for a feature that is off.
//
// To re-enable, move the idle subscriptions to a mount-once sync hook backed by a
// shared store (Pattern B) so the timers/listeners run once app-wide instead of
// once per consumer, and have consumers read the shared result.
const useIdleLevels = (): IdleLevelsState => DEFAULT_STATE;

export default useIdleLevels;
